import { useCallback, useState } from 'react'

export interface CompareSalesTarget {
  fpCode: string
  lsId: string
  xeroInvoiceId?: string | null
  invoiceNumber?: string
  xeroReference?: string
  xeroInvoiceNumber?: string
  lightspeedSaleLink?: string
  xeroInvoiceLink?: string
}

export interface CompareSalesDialogProps {
  open: boolean
  target: CompareSalesTarget | null
  onClose: () => void
}

export interface UseCompareSalesDialogReturn {
  open: (target: CompareSalesTarget) => void
  close: () => void
  dialogProps: CompareSalesDialogProps
}

export function useCompareSalesDialog(): UseCompareSalesDialogReturn {
  const [target, setTarget] = useState<CompareSalesTarget | null>(null)

  const open = useCallback((next: CompareSalesTarget) => {
    setTarget(next)
  }, [])

  const close = useCallback(() => {
    setTarget(null)
  }, [])

  return {
    open,
    close,
    dialogProps: {
      open: target !== null,
      target,
      onClose: close,
    },
  }
}

export default useCompareSalesDialog
